import { GDFPalletCode } from '../../../gdf/type';
import palettes from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const dynamicSuaLayers: StyleFactory = (baseId) => {
    const colors = generateColorExpressionFromPalette(palettes[GDFPalletCode.dsua], ['get', 'color']);
    return [
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-fill',
            pickable: true,
            paint: {
                'fill-color': colors,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            type: 'line',
            source: baseId,
            id: baseId + '-line',
            paint: {
                'line-color': colors,
                'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 4, 2]
            }
        },
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-hover',
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        }
    ];
};
